export const SET_SUBSCRIPTIONS = 'SET_SUBSCRIPTIONS';


// WEBPACK FOOTER //
// ./src/store/modules/subscriptions/mutations.js